import {
	ADMINGETFEEOPERATIONTYPE_SUCCESS,
	ADMINGETFEEOPERATIONTYPE_FAILED,
	RESET_ADMINGETFEEOPERATIONTYPE,
	LOADING_ADMINGETFEEOPERATIONTYPE,
	NETWORK_ERROR_ADMINGETFEEOPERATIONTYPE
} from "../types/index";

const initialState = {
	isLoading: false,
	success: false,
	network: false,
	failed: false,
	data: {}
};

export default (state = initialState, action) => {
	switch (action.type) {
		case LOADING_ADMINGETFEEOPERATIONTYPE:
			return {
				...state,
				isLoading: true,
				success: false,
				failed: false,
				network: false,
				data: {}
			};
		case ADMINGETFEEOPERATIONTYPE_FAILED:
			return {
				...state,
				isLoading: false,
				success: false,
				failed: true,
				network: false,
				data: action.payload
			};
		case ADMINGETFEEOPERATIONTYPE_SUCCESS:
			return {
				...state,
				isLoading: false,
				success: true,
				failed: false,
				network: false,
				data: action.payload
			};
		case NETWORK_ERROR_ADMINGETFEEOPERATIONTYPE:
			return {
				...state,
				isLoading: false,
				success: false,
				failed: false,
				network: true,
				data: {}
			};
		case RESET_ADMINGETFEEOPERATIONTYPE:
			return (state = initialState);
		default:
			return state;
	}
};
